(function(){
"use strict";

const fmt = n => "$" + n.toLocaleString("es-CL");
// Precios copiados de Kaching el 16-10 (en la versión final salen de Kaching o de metacampos)
const PACKS = [
  {id:"p1", name:"1 Plant+", short:"1 Plant+", days:25, perDay:1600, price:39990, was:null, free:true},
  {id:"p2", name:"2 Plant+", short:"2 Plant+", days:50, perDay:1200, price:59998, was:79980, free:true, tag:"Ahorras $19.982"}
];
const pk = id => PACKS.find(x => x.id === id);
const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
const buyEl = () => document.querySelector("kaching-bundle") || document.querySelector(".product-form") || document.querySelector(".product__info-container");
const go = () => { const b = buyEl(); if (b) b.scrollIntoView({behavior: reduce ? "auto" : "smooth", block: "center"}); };
function pickK(id){
  const i = {p1:0, p2:1}[id];
  const bars = [...document.querySelectorAll("kaching-bundle .kaching-bundles__bar")].filter(b => !b.classList.contains("kaching-bundles__checkbox-upsells__upsell"));
  if (bars[i]) bars[i].click();
  go();
}
function render(){
  document.querySelectorAll("[data-strip]").forEach(el => {
    el.innerHTML = PACKS.map(p => `<button class="spt" role="radio" aria-checked="false" data-id="${p.id}">
      ${p.tag ? `<span class="tg">${p.tag}</span>` : ""}
      <b>${p.name}</b><span class="pr num">${fmt(p.price)}</span><span class="pd num">${fmt(p.perDay)} la porción</span>
      <span class="sh">${p.free ? "Despacho gratis" : "Despacho aparte"}</span></button>`).join("");
  });
  const sr = document.getElementById("sRows");
  if (sr) sr.innerHTML = [pk("p1"), pk("p2")].map(r => `<span class="s-row ${r.id==="p2" ? "hi" : ""}"><span class="n">${r.short}</span><b class="num">${fmt(r.perDay)}/porción</b><span class="num">${fmt(r.price)}</span></span>`).join("");
}
document.addEventListener("click", e => {
  const sb = e.target.closest(".lp .spt"); if (sb) { pickK(sb.dataset.id); return; }
  const dp = e.target.closest(".lp [data-pick]"); if (dp) { pickK(dp.dataset.pick); return; }
  if (e.target.closest("#sBtn")) go();
});
render();
// Despacho según la hora de Santiago
function despacho(){
  let h = 12;
  try { h = +new Intl.DateTimeFormat("es-CL", {timeZone:"America/Santiago", hour:"numeric", hourCycle:"h23"}).format(new Date()); } catch(e) {}
  const DIAS = ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"];
  let d = new Date();
  try { const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", {timeZone:"America/Santiago", year:"numeric", month:"numeric", day:"numeric"}).formatToParts(d).map(x => [x.type, x.value])); d = new Date(+p.year, +p.month - 1, +p.day); } catch(e) {}
  // Feriados irrenunciables (Ley 19.973): ese día no hay despacho, pasa al día siguiente
  const FER = ["2026-01-01","2026-05-01","2026-09-18","2026-09-19","2026-12-25","2027-01-01","2027-05-01","2027-09-18","2027-09-19","2027-12-25"];
  const ymd = x => x.getFullYear() + "-" + String(x.getMonth() + 1).padStart(2, "0") + "-" + String(x.getDate()).padStart(2, "0");
  let k = h >= 12 ? 1 : 0;
  d.setDate(d.getDate() + k);
  while (FER.includes(ymd(d))) { d.setDate(d.getDate() + 1); k++; }
  const txt = `Llega ${k === 0 ? "hoy" : k === 1 ? "mañana" : "el"} ${DIAS[d.getDay()]} ${d.getDate()} (RM)`;
  document.querySelectorAll("[data-ship]").forEach(el => el.textContent = txt);
}
despacho(); setInterval(despacho, 60000);

// Resultados: el detalle se abre bajo la fila del ícono tocado
const IC = {
  bone:'<path d="M8.5 4.5a2.6 2.6 0 0 0-3.9 3.1 2.6 2.6 0 1 0 2.6 4.1l5.1 5.1a2.6 2.6 0 1 0 4.1 2.6 2.6 2.6 0 1 0 3.1-3.9 2.6 2.6 0 0 0-3.2-1.2l-5.1-5.1a2.6 2.6 0 0 0-2.7-4.7z" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linejoin="round"/>',
  bolt:'<path d="M13 2 5 13h6l-1 9 8-12h-6l1-8z" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linejoin="round"/>',
  gut:'<path d="M9 3v3c0 2 1.5 3 3.5 3S16 10 16 12s-1.5 3-3.5 3S9 16 9 18v3" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linecap="round"/>',
  spark:'<path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linejoin="round"/><path d="M18 16l.7 1.8 1.8.7-1.8.7L18 21l-.7-1.8-1.8-.7 1.8-.7z" fill="#1A1B18"/>',
  focus:'<circle cx="12" cy="12" r="8.5" fill="none" stroke="#1A1B18" stroke-width="2"/><circle cx="12" cy="12" r="4.5" fill="none" stroke="#1A1B18" stroke-width="2"/><circle cx="12" cy="12" r="1.3" fill="#1A1B18"/>',
  citrus:'<circle cx="12" cy="12" r="8.5" fill="none" stroke="#1A1B18" stroke-width="2"/><path d="M12 3.5v17M3.5 12h17M6 6l12 12M18 6 6 18" stroke="#1A1B18" stroke-width="1.4"/>',
  moon:'<path d="M21 13.5A8.5 8.5 0 1 1 10.5 3a6.6 6.6 0 0 0 10.5 10.5z" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linejoin="round"/>',
  pulse:'<path d="M3 12h3l2.5-6 4 12 2.5-6H21" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>',
  drop:'<path d="M12 3c3 4 6 7.5 6 11a6 6 0 0 1-12 0c0-3.5 3-7 6-11z" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linejoin="round"/><path d="M9.5 14.5a2.5 2.5 0 0 0 2.5 2.5" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linecap="round"/>'
};
const OUT = [
  {ic:"bolt", area:"Músculo", pain:"En lo que construyes al entrenar.", win:"Que tu entrenamiento se note", body:"Cuando entrenas, tu músculo necesita proteína para crecer: las proteínas contribuyen a aumentar la masa muscular. Plant+ trae 20-21 g por porción, con los 9 aminoácidos esenciales, los que el cuerpo no fabrica. Tómala después de entrenar o cuando te falte proteína en el día.", d:[["Proteína","20-21 g"],["Esenciales","Los 9"]]},
  {ic:"pulse", area:"Día a día", pain:"En el músculo que mantienes.", win:"Músculo que se queda contigo", body:"Tu músculo es parte de estar bien, a cualquier edad. Las proteínas contribuyen a conservar la masa muscular. Cada porción trae 20-21 g de proteína vegetal, sin lácteos ni soya.", d:[["Proteína","20-21 g"],["Origen","100% vegetal"]]},
  {ic:"bone", area:"Huesos", pain:"En tu estructura, a largo plazo.", win:"Proteína y fósforo para tus huesos", body:"Las proteínas y el fósforo contribuyen al mantenimiento de los huesos en condiciones normales. Cada porción trae el 32-34% del fósforo diario.", d:[["Fósforo","32-34%"],["Proteína","20-21 g"]]},
  {ic:"gut", area:"Estómago", pain:"Si otras proteínas te caen pesadas.", win:"Proteína que te cae liviana", body:"Sin lácteos, sin soya y sin polioles (los del estómago inflado). Proteína que se toma y se sigue con el día.", d:[["Lácteos","0"],["Polioles","0"]], q:["Sabor muy agradable. No cae mal. Recomendable.","Susana C."]}
];
let oi = 0;
const og = document.getElementById("og");
const wide = matchMedia("(min-width: 720px)");
function renderOut(){
  if (!og) return;
  const tiles = OUT.map((o,i) => `<button class="ot" aria-expanded="${i===oi}" aria-controls="od" data-i="${i}">
      <span class="top"><span class="ic"><svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">${IC[o.ic]}</svg></span><span class="chev" aria-hidden="true">▾</span></span>
      <b>${o.area}</b><span class="p">${o.pain}</span></button>`);
  tiles.push(`<button class="ot cta" data-pick="p2"><b>Todo esto en 2 scoops</b><span class="p">Desde $1.200 la porción →</span></button>`);
  let html = "";
  const per = wide.matches ? 4 : 2;
  for (let r = 0; r < tiles.length; r += per) {
    html += tiles.slice(r, r + per).join("");
    if (oi >= 0 && Math.floor(oi/per) === r/per) {
      const o = OUT[oi];
      html += `<div class="od" id="od" role="region" aria-label="${o.area}"><p class="label">${o.area}</p><p class="win">${o.win}</p><p>${o.body}</p><div class="doses">${o.d.map(x=>`<span class="dose">${x[0]} <b>${x[1]}</b></span>`).join("")}</div>${o.q ? `<q>"${o.q[0]}"<cite>${o.q[1]} <span class="cv">✓ Compra verificada</span></cite></q>` : ""}</div>`;
    }
  }
  og.innerHTML = html;
}
if (og) og.addEventListener("click", e => {
  const b = e.target.closest(".ot:not(.cta)"); if (!b) return;
  const i = +b.dataset.i; oi = (oi === i) ? -1 : i; renderOut();
  og.querySelector(`[data-i="${i}"]`).focus();
});
renderOut();
wide.addEventListener("change", renderOut);

// Etiqueta
const lm = document.getElementById("labelModal"); let lastFocus = null;
if (lm) {
  document.querySelectorAll("[data-label]").forEach(b => b.addEventListener("click", () => { lastFocus = b; lm.hidden = false; document.getElementById("labelClose").focus(); }));
  const closeLm = () => { lm.hidden = true; if (lastFocus) lastFocus.focus(); };
  document.getElementById("labelClose").addEventListener("click", closeLm);
  lm.addEventListener("click", e => { if (e.target === lm) closeLm(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape" && !lm.hidden) closeLm(); });
}
if (reduce) document.querySelectorAll(".lp video").forEach(v => { v.removeAttribute("autoplay"); v.pause(); });

// Barra fija: aparece solo cuando no hay otra compra a la vista (sin ruido de botones)
(function(){
  const bar = document.querySelector(".lp .sticky"); if (!bar) return;
  const zones = () => [document.querySelector(".product__info-container"), document.querySelector(".lp-galeria"), ...document.querySelectorAll(".lp .strip"), document.querySelector(".lp .final")].filter(Boolean);
  const update = () => {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const hide = zones().some(z => { const r = z.getBoundingClientRect(); return r.bottom > 0 && r.top < vh - 40; });
    bar.classList.toggle("is-hidden", hide); bar.toggleAttribute("inert", hide);
  };
  addEventListener("scroll", update, {passive: true}); addEventListener("resize", update);
  update();
})();

// Galería propia: se mueve a la columna de fotos del theme y se arma el carrusel
(function(){
  const g = document.querySelector(".lp-galeria"), mw = document.querySelector(".product__media-wrapper");
  if (g && mw) { mw.prepend(g); document.documentElement.classList.add("lp-gal-ok"); }
  const tr = document.getElementById("track"); if (!tr) return;
  const slides = [...tr.children], n = slides.length;
  const dots = document.getElementById("dots"), th = document.getElementById("thumbs"), cnt = document.getElementById("gcount");
  dots.innerHTML = slides.map((s, i) => `<button class="dot" data-go-slide="${i}" aria-label="Ir a: ${s.dataset.name}"></button>`).join("");
  th.innerHTML = "";
  slides.forEach((s, i) => {
    const b = document.createElement("button"); b.className = "th"; b.dataset.goSlide = i; b.setAttribute("aria-label", "Ir a: " + s.dataset.name);
    const c = s.cloneNode(true); c.setAttribute("aria-hidden", "true"); c.removeAttribute("data-name");
    c.querySelectorAll("video").forEach(v => { const im = document.createElement("img"); im.className = "vposter"; im.src = (s.querySelector("video") || {}).poster || ""; im.alt = ""; v.replaceWith(im); });
    c.querySelectorAll("button,[data-label]").forEach(x => { x.removeAttribute("data-label"); x.setAttribute("tabindex", "-1"); });
    b.appendChild(c); th.appendChild(b);
  });
  const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : tr.clientWidth);
  const idx = () => Math.round(tr.scrollLeft / step());
  const mark = () => { const k = idx(); cnt.textContent = (k + 1) + " / " + n; document.querySelectorAll("[data-go-slide]").forEach(b => b.setAttribute("aria-current", +b.dataset.goSlide === k ? "true" : "false")); };
  const goS = k => { k = (k + n) % n; tr.scrollTo({left: k * step()}); };
  tr.addEventListener("scroll", mark, {passive:true});
  tr.addEventListener("keydown", e => { if (e.key === "ArrowRight") goS(idx() + 1); if (e.key === "ArrowLeft") goS(idx() - 1); });
  document.addEventListener("click", e => {
    const d = e.target.closest("[data-go-slide]"); if (d) { goS(+d.dataset.goSlide); return; }
    const g2 = e.target.closest("[data-gnav]"); if (g2) goS(idx() + +g2.dataset.gnav);
  });
  mark();
})();

// Sabor visual: botones sobre el selector real de Kaching (uno por tarro). La lámina 1 muestra el sabor del primer tarro.
(function(){
  const SAB = [["Vainilla","#F3E6C4"],["Chocolate Negro","#5B3A29"]];
  const bars = () => [...document.querySelectorAll("kaching-bundle .kaching-bundles__bars > .kaching-bundles__bar")];
  function lam1(){
    const sel = document.querySelector("kaching-bundle .kaching-bundles__bars > .kaching-bundles__bar--selected select.kaching-bundles__bar-variant-select");
    const im = document.getElementById("lpPlantProd"); if (!sel || !im) return;
    const src = sel.value === "Chocolate Negro" ? im.dataset.chocolate : im.dataset.vainilla;
    if (im.getAttribute("src") !== src) { im.setAttribute("src", src); const th = document.querySelector("#thumbs .s-prod-img"); if (th) th.setAttribute("src", src); }
  }
  function arma(){
    bars().forEach(bar => {
      const ws = [...bar.querySelectorAll(".kaching-bundles__bar-variant-selector-wrapper")];
      ws.forEach((w, i) => {
        const sel = w.querySelector("select.kaching-bundles__bar-variant-select"); if (!sel) return;
        let g = w.querySelector(".lp-sab");
        if (!g) {
          g = document.createElement("div"); g.className = "lp-sab"; g.setAttribute("role", "radiogroup");
          g.setAttribute("aria-label", ws.length > 1 ? "Sabor del tarro " + (i + 1) : "Sabor");
          g.innerHTML = (ws.length > 1 ? `<span class="lp-sab-n">Tarro ${i + 1}</span>` : `<span class="lp-sab-n">Sabor</span>`) +
            SAB.map(s => `<button type="button" role="radio" class="lp-sab-b" data-v="${s[0]}"><i style="background:${s[1]}"></i>${s[0]}</button>`).join("");
          w.prepend(g);
        }
        g.querySelectorAll(".lp-sab-b").forEach(b => b.setAttribute("aria-checked", b.dataset.v === sel.value ? "true" : "false"));
      });
    });
    lam1();
  }
  document.addEventListener("click", e => {
    const b = e.target.closest("kaching-bundle .lp-sab-b"); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    const sel = b.closest(".kaching-bundles__bar-variant-selector-wrapper").querySelector("select.kaching-bundles__bar-variant-select");
    if (sel && sel.value !== b.dataset.v) { sel.value = b.dataset.v; sel.dispatchEvent(new Event("input", {bubbles:true})); sel.dispatchEvent(new Event("change", {bubbles:true})); }
    setTimeout(arma, 60);
  }, true);
  let t, n = 0;
  const iv = setInterval(() => {
    const k = document.querySelector("kaching-bundle .kaching-bundles__bars");
    if (k) { clearInterval(iv); arma(); new MutationObserver(() => { clearTimeout(t); t = setTimeout(arma, 60); }).observe(document.querySelector("kaching-bundle"), {subtree:true, childList:true, attributes:true, attributeFilter:["class","data-value"]}); }
    else if (++n > 40) clearInterval(iv);
  }, 300);
  document.addEventListener("change", e => { if (e.target.matches && e.target.matches("kaching-bundle select")) setTimeout(arma, 60); }, true);
})();

// Reseñas de Plant+: se suman solas las nuevas de Judge.me (4-5 estrellas, no muy cortas). Las del HTML son el respaldo.
(function(){
  const box = document.getElementById("rvPlant"); if (!box || !window.fetch) return;
  const url = "https://api.judge.me/reviews/reviews_for_widget?url=basics-chile.myshopify.com&shop_domain=basics-chile.myshopify.com&platform=shopify&page=1&per_page=20&product_id=8711292158151";
  fetch(url).then(r => r.ok ? r.json() : null).then(j => {
    if (!j || !j.html) return;
    const doc = new DOMParser().parseFromString(j.html, "text/html");
    const ya = new Set([...box.querySelectorAll("blockquote")].map(b => b.dataset.a).concat(["VICTORIA S.J.","María E.R.","Susana C.","Jonathan M.A.G.G."]));
    let n = 0;
    doc.querySelectorAll(".jdgm-rev").forEach(r => {
      const st = +(r.querySelector("[data-score]") || {dataset:{}}).dataset.score || 0;
      const au = ((r.querySelector(".jdgm-rev__author") || {}).textContent || "").trim();
      const tx = ((r.querySelector(".jdgm-rev__body") || {}).textContent || "").replace(/\s+/g, " ").trim();
      if (st < 4 || tx.length < 40 || !au || ya.has(au) || n >= 6) return;
      const q = document.createElement("blockquote"); q.dataset.a = au;
      q.innerHTML = '<span class="stars"></span><p></p><cite></cite>'; q.querySelector(".stars").textContent = "★".repeat(st) + "☆".repeat(5 - st);
      q.querySelector("p").textContent = "“" + tx + "”"; q.querySelector("cite").textContent = au;
      box.appendChild(q); ya.add(au); n++;
    });
    if (box.children.length >= 3) box.classList.add("rv-3");
  }).catch(() => {});
})();

})();
